import React from "react";

import { HubContextMenu } from "../../components";
import {
  useDeleteLead,
  useDeleteQuote,
} from "../../hooks/react-query/useSalesData";

const MENU_ITEMS = [
  { id: "edit", label: "Edit", icon: "Edit" },
  { id: "delete", label: "Delete", icon: "Trash2", color: "redError" },
];

const SalesContextMenu = ({ itemId, type = "lead", onEdit = () => {} }) => {
  const { mutate: deleteLead } = useDeleteLead();
  const { mutate: deleteQuote } = useDeleteQuote();

  const onSelect = (selected) => {
    switch (selected?.id) {
      case "edit":
        onEdit();
        break;
      case "delete":
        if (type === "lead") deleteLead(Number(itemId));
        else deleteQuote(Number(itemId));
        break;
      default:
        break;
    }
  };

  return (
    <HubContextMenu
      id={`${type}-${itemId}`}
      loading={false}
      menuItems={MENU_ITEMS}
      onSelect={onSelect}
      IconButtonProps={{ sx: { padding: "2px" } }}
      HubIconProps={{ size: 12 }}
    />
  );
};

export default SalesContextMenu;
